import { FiltersState } from '@customer/store/slices/filtersSlice';
import { ComponentType, ReactElement, Ref } from 'react';

export interface FilterInputProps<T> {
  label?: ReactElement | string;
  elementRef: Ref<T>;
}

export type FilterElementType =
  | HTMLVdsBasicInputElement
  | HTMLVdsBasicDropdownElement
  | HTMLVdsBasicDropdownMultiselectElement;

export enum FilterElement {
  VdsInput = 'HTMLVdsBasicInputElement',
  VdsDropdown = 'HTMLVdsBasicDropdownElement',
  VdsDropdownMultiselect = 'HTMLVdsBasicDropdownMultiselectElement',
}

export type FilterName = keyof FiltersState;

interface FilterConfigModel<T extends FilterElementType, E extends FilterElement> {
  name: FilterName;
  FilterComponent: ComponentType<FilterInputProps<T>>;
  elementType: E;
}

type NumberFilterConfig = FilterConfigModel<HTMLVdsBasicInputElement, FilterElement.VdsInput>;
type DropdownFilterConfig = FilterConfigModel<
  HTMLVdsBasicDropdownElement,
  FilterElement.VdsDropdown
>;
type DropdownMultiselectFilterConfig = FilterConfigModel<
  HTMLVdsBasicDropdownMultiselectElement,
  FilterElement.VdsDropdownMultiselect
>;

export type FilterConfig =
  | NumberFilterConfig
  | DropdownFilterConfig
  | DropdownMultiselectFilterConfig;

export interface FilterWithOptions {
  name: FilterName;
  fullWidth?: boolean;
  labelTransKey?: string;
}

export type FiltersList = Array<FilterName | FilterWithOptions>;

export enum FilterGroup {
  AssetsList = 'AssetsList',
  AssetSelfTest = 'AssetSelfTest',
  AssetVI = 'AssetVI',
  AssetGI = 'AssetGI',
  HealthSummary = 'HealthSummary',
  HealthSelfTest = 'HealthSelfTest',
  HealthSoftwareStatus = 'HealthSoftwareStatus',
  HealthReporting = 'HealthReporting',
  Investigations = 'Investigations',
  PartnerResources = 'PartnerResources',
  PerformanceVI = 'PerformanceVI',
  PerformanceGI = 'PerformanceGI',
  TechLibrary = 'TechLibrary',
}
